import { BaseDto } from "@models/base/baseDto.model";

export class TipoMovimientoDto extends BaseDto{
    public resta!: boolean
    public editable!: boolean
    public esAnulable!: boolean
    public tieneComision !: boolean

    /**
     * Ligature de Material Icons; null/undefined = la pantalla usa el genérico.
     *
     * Opcional a propósito: hay pantallas que arman un TipoMovimientoDto a mano
     * para movimientos que no existen en la base (saldo a favor, bonificación
     * calculada). Esos literales no tienen icono que poner y obligarlos a
     * declararlo sería pedirles un dato que no les corresponde.
     */
    public icono?: string | null
}
